module.exports = __webpack_public_path__ + "static/CircularStd-Book-6365c40aa59d462f1cc52ccce9635cb4.otf";